import cl from 'classnames'
import { PropsWithChildren, useRef } from 'react'

type Props = {
  className?: string
}

const AnimatedCarouselRoot = ({
  className,
  children
}: PropsWithChildren<Props>) => {
  const containerRef = useRef<HTMLDivElement>(null)

  return (
    <div
      ref={containerRef}
      className={cl(
        'w-full h-auto snap-always snap-start flex flex-col items-center justify-center overflow-hidden pt-1 md:pt-14',
        className
      )}
    >
      {children}
    </div>
  )
}

export const Root = AnimatedCarouselRoot
